(function() {
    var TABLET_BREAKPOINT = 1024;
    
    var sectionTitleObserver = null;
    var summaryPreviewObserver = null;
    
    var sectionTitleVisible = true;
    var summaryPreviewVisible = false;
    var summaryPreviewPassed = false;
    
    var preview = null;
    var placeholder = null;
    var sectionTitle = null;
    var summaryPreview = null;
    
    var originalHeight = 0;
    
    function updateStickyState() {
        if (!preview || !placeholder) return;
        
        var shouldBeSticky = !sectionTitleVisible && !summaryPreviewVisible && !summaryPreviewPassed;
        
        if (shouldBeSticky) {
            preview.classList.add('is-sticky');
            placeholder.classList.add('is-active');
            placeholder.style.height = originalHeight + 'px';
        } else {
            preview.classList.remove('is-sticky');
            placeholder.classList.remove('is-active');
            placeholder.style.height = '';
        }
    }
    
    function initObservers() {
        preview = document.querySelector('.customization-preview');
        placeholder = document.querySelector('.customization-preview-placeholder');
        sectionTitle = document.querySelector('.section-title');
        summaryPreview = document.querySelector('.summary-preview');
        
        if (!preview || !placeholder || !sectionTitle || !summaryPreview) return;
        
        // desktop - no sticky
        if (window.innerWidth > TABLET_BREAKPOINT) {
            cleanup();
            return;
        }
        
        originalHeight = preview.offsetHeight;
        
        // section title observer
        sectionTitleObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                sectionTitleVisible = entry.isIntersecting;
                updateStickyState();
            });
        }, { threshold: 0 });
        
        // summary preview observer
        summaryPreviewObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    summaryPreviewVisible = true;
                } else {
                    summaryPreviewVisible = false;
                    summaryPreviewPassed = entry.boundingClientRect.top < 0;
                }
                updateStickyState();
            });
        }, { threshold: 0 });
        
        sectionTitleObserver.observe(sectionTitle);
        summaryPreviewObserver.observe(summaryPreview);
    }
    
    function cleanup() {
        sectionTitleVisible = true;
        summaryPreviewVisible = false;
        summaryPreviewPassed = false;
        
        if (preview) preview.classList.remove('is-sticky');
        if (placeholder) {
            placeholder.classList.remove('is-active');
            placeholder.style.height = '';
        }
        
        if (sectionTitleObserver) {
            sectionTitleObserver.disconnect();
            sectionTitleObserver = null;
        }
        if (summaryPreviewObserver) {
            summaryPreviewObserver.disconnect();
            summaryPreviewObserver = null;
        }
    }
    
    // resize handler
    var resizeTimeout;
    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            cleanup();
            initObservers();
        }, 100);
    }
    
    // init
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObservers);
    } else {
        initObservers();
    }
    
    window.addEventListener('resize', handleResize);
})();